import templateUrl from 'emun.salesrep/salesrep-review-orders.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import orderConfig from 'emun.order/order.config';

class SalesRepReviewOrdersController {
	constructor($rootScope) {
		const $ctrl = this;
		basicController($ctrl);
		var context = $ctrl.context || 'rep';
		$ctrl.orderConfig = orderConfig;
		console.info("this rep", this);
		var filter = "SalesRepID";
		if (context == 'manager') {
			filter = "ManagerId" + '=' + this.repId;
		} else if (context == 'vendor') {
			filter = "VendorId" + '=' + this.repId;
		} else if (context == 'subrep') {
			filter = 'SubRepId' + '=' + this.repId;
		} else {
			filter = filter + '=' + this.repId;
			if ($ctrl.repGroup) {
				if ($ctrl.repGroup !== 'ALL') {
					filter = filter + '&RepGroup=' + $ctrl.repGroup;
				}
			}
		}
		
		$ctrl.reviewOrders = new AutoQuery({
			url: 'QueryCartsJoin.json?StatusEqual=Review&ReviewReason=' + $ctrl.reason + '&' + filter,
			orderBy: '-OrderedOn',
			autoLoad: true,
			pageSize: 10,
			scrollTop: false
		})
		//$ctrl.openItems = new AutoQuery({
		//    url: 'QueryCartItemsJoin.json?CartStatusNotEqualTo=Cart&' + filter + '=' + this.repId,
		//    orderBy: '-OrderedOn',
		//    autoLoad: true,
		//    pageSize: 10
		//})
	}
}

let SalesRepReviewOrders = {
	bindings: {
		repId: '@',
		reason: '@',
		rep: '<',
		repGroup: '@',
		context: '@'
	},
	controller: SalesRepReviewOrdersController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl
	}
}

export default SalesRepReviewOrders